export const ContactResourcesDA = {
  title: "Kontakt",
  name: "Navn",
  email: "Email",
  message: "Besked",
  send: "Send",
  details: "Aida Bikic, Ph.d.",
  // booking removed
  newsletterTitle: "Foredrag",
  newsletterDescription:
    "Interesseret i at booke et foredrag? Send mig dine oplysninger, så vender jeg tilbage til dig.",
  newsletterFullName: "Fulde navn",
  newsletterEmail: "Email adresse",
  newsletterDescriptionLabel: "Beskrivelse (valgfri)",
  newsletterSubscribe: "Anmod om foredrag",
  newsletterSuccess:
    "Tak! Din anmodning er modtaget. Jeg vender tilbage til dig snarest.",
  newsletterError: "Der opstod en fejl. Prøv igen senere.",
  newsletterEmailExists: "Denne email er allerede registreret.",
  subscribeTitle: "NYHEDSBREV",
  subscribeDescription:
    "Tilmeld dig nyhedsbrevet for opdateringer om foredrag, artikler og events.",
  subscribeButton: "Tilmeld",
  subscribeSuccess: "Tak! Du er nu tilmeldt nyhedsbrevet.",
  subscribeExists: "Denne email er allerede tilmeldt.",
  // booking removed
};

export const ContactResourcesEN = {
  title: "Contact",
  name: "Name",
  email: "Email",
  message: "Message",
  send: "Send",
  details: "Aida Bikic, Ph.D.",
  // booking removed
  newsletterTitle: "LECTURE",
  newsletterDescription:
    "Interested in booking a lecture? Send me your details and I'll get back to you.",
  newsletterFullName: "Full name",
  newsletterEmail: "Email address",
  newsletterDescriptionLabel: "Description (optional)",
  newsletterSubscribe: "Request lecture",
  newsletterSuccess:
    "Thank you! Your request has been received. I'll get back to you soon.",
  newsletterError: "An error occurred. Please try again later.",
  newsletterEmailExists: "This email is already registered.",
  subscribeTitle: "NEWSLETTER",
  subscribeDescription:
    "Subscribe to the newsletter for updates on lectures, articles and events.",
  subscribeButton: "Subscribe",
  subscribeSuccess: "Thank you! You are now subscribed to the newsletter.",
  subscribeExists: "This email is already subscribed.",
  // booking removed
};

export const ContactResourcesDE = {
  title: "Kontakt",
  name: "Name",
  email: "E-Mail",
  message: "Nachricht",
  send: "Senden",
  details: "Aida Bikic, Ph.D.",
  // booking removed
  newsletterTitle: "VORTRAG",
  newsletterDescription:
    "Interessiert an der Buchung eines Vortrags? Senden Sie mir Ihre Daten und ich melde mich bei Ihnen zurück.",
  newsletterFullName: "Vollständiger Name",
  newsletterEmail: "E-Mail-Adresse",
  newsletterDescriptionLabel: "Beschreibung (optional)",
  newsletterSubscribe: "Vortrag anfragen",
  newsletterSuccess:
    "Vielen Dank! Ihre Anfrage wurde erhalten. Ich melde mich bald bei Ihnen zurück.",
  newsletterError:
    "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
  newsletterEmailExists: "Diese E-Mail ist bereits registriert.",
  subscribeTitle: "NEWSLETTER",
  subscribeDescription:
    "Abonnieren Sie den Newsletter für Updates zu Vorträgen, Artikeln und Veranstaltungen.",
  subscribeButton: "Abonnieren",
  subscribeSuccess: "Danke! Sie haben den Newsletter abonniert.",
  subscribeExists: "Diese E-Mail ist bereits angemeldet.",
  // booking removed
};

export const ContactResourcesBS = {
  title: "Kontakt",
  name: "Ime",
  email: "Email",
  message: "Poruka",
  send: "Pošalji",
  details:
    "Aida Bikic, Ph.D. — email: abikic@icloud.com — Tel. +45 29 16 82 16",
  // booking removed
  newsletterTitle: "PREDAVANJE",
  newsletterDescription:
    "Zainteresovani za rezervaciju predavanja? Pošaljite mi vaše podatke i javit ću vam se.",
  newsletterFullName: "Puno ime",
  newsletterEmail: "Email adresa",
  newsletterDescriptionLabel: "Opis (opcionalno)",
  newsletterSubscribe: "Zatraži predavanje",
  newsletterSuccess: "Hvala! Vaš zahtjev je primljen. Javit ću vam se uskoro.",
  newsletterError: "Došlo je do greške. Molimo pokušajte ponovo kasnije.",
  newsletterEmailExists: "Ovaj email je već registriran.",
  subscribeTitle: "NEWSLETTER",
  subscribeDescription:
    "Pretplatite se na newsletter za novosti o predavanjima, člancima i događajima.",
  subscribeButton: "Pretplati se",
  subscribeSuccess: "Hvala! Uspješno ste se pretplatili na newsletter.",
  subscribeExists: "Ovaj email je već pretplaćen.",
  // booking removed
};
